export default {"src":"/_next/static/media/partner17.116a69c4.svg","height":84,"width":148,"blurWidth":0,"blurHeight":0};